import { combineReducers } from 'redux';
import clientInfoReducer from './infoReducer';
import sopReducer from './sops';

/* global Redux */
const clientReducer = function() {
  return combineReducers({
    info: clientInfoReducer,
    sops: sopReducer,
  });
};


export default clientReducer();
